
import {ModalWrapper, Reoverlay} from "reoverlay";
import 'reoverlay/lib/ModalWrapper.css';
import {MdClose} from "react-icons/md";
import React from "react";
import Button from "../Button";
const ServiceModal=({service,img})=>{

    const handleClose=()=>{

    }
    const handleClick=(char)=>{

        Reoverlay.hideModal();
    }
    return <ModalWrapper  onClose={handleClose}  animation="zoom" contentContainerClassName="w-11/12 md:w-5/12  bg-gray-50 lg:w-4/12 p-5 rounded-xl">
        <div className="flex justify-center flex-col items-center">

            <h1 className=" text-center font-bold text-lg">{service?.faName}</h1>
            {img && <img src={img} alt="" className="w-10/12 mt-2"/>}
            <p className="text-sm text-center mt-2 mb-5">{service?.guide}</p>


            <div className="grid-cols-1 grid w-full">
                <div className="flex justify-center">
                    {service?.disabled_txt && <div className="text-red-400 text-sm ">{service?.disabled_txt }</div>}
                </div>
                <Button onClick={handleClick} rounded="rounded-lg" className="w-full" theme="blue">بستن</Button>
            </div>
        </div>

            </ModalWrapper>
}
export default ServiceModal;